import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import { createMutationAtom } from 'atoms/create-resource-atom';
import type {
  CountyCoverageResponse,
  CountyCoverageFacets,
  CountyCoverageSummaryResponse,
} from 'types/api-responses';

export interface CountyCoverageParams extends SearchParams {
  stateIds?: number[];
  countyIds?: number[];
  dateFilter?: {
    type: string;
    start?: string;
    end?: string;
  };
}

const getDateValue = (value: string | null): string | undefined => {
  if (!value || value === 'undefined') {
    return undefined;
  }
  return value;
};

export const createCountyCoverageSearchAtom = (
  pageSizePreference: number = 100
) => {
  const params = new URLSearchParams(window.location.search);

  const stateIdsParam = params.get('stateIds');
  const countyIdsParam = params.get('countyIds');
  const stateIds = stateIdsParam
    ? stateIdsParam
        .split(',')
        .map(Number)
        .filter((n) => !isNaN(n))
    : undefined;
  const countyIds = countyIdsParam
    ? countyIdsParam
        .split(',')
        .map(Number)
        .filter((n) => !isNaN(n))
    : undefined;

  const dateFilterType = params.get('dateFilterType');
  const dateStart = params.get('dateStart');
  const dateEnd = params.get('dateEnd');
  const dateFilterTypeIsSet = dateFilterType && dateFilterType !== 'none';
  const dateStartOrEndIsSet = dateStart || dateEnd;
  const shouldSendDateFilter = dateFilterTypeIsSet && dateStartOrEndIsSet;
  const dateFilter = shouldSendDateFilter
    ? {
        type: dateFilterType,
        start: getDateValue(dateStart),
        end: getDateValue(dateEnd),
      }
    : undefined;

  return searchAtomPair<
    CountyCoverageResponse,
    CountyCoverageParams,
    CountyCoverageFacets
  >(
    { href: '/queries/county_coverage' },
    {
      page: parseInt(params.get('page') || '1', 10),
      pageSize: parseInt(
        params.get('pageSize') || String(pageSizePreference),
        10
      ),
      text: params.get('text') || undefined,
      sortAttribute: params.get('sortAttribute') || 'documentCount',
      sortDirection: (params.get('sortDirection') as 'ASC' | 'DESC') || 'DESC',
      stateIds,
      countyIds,
      dateFilter,
    }
  );
};

export const countyCoverageSummaryAtom = createMutationAtom<
  CountyCoverageSummaryResponse,
  'countyCoverageSummary'
>();
